export const colors = {
  richBlack: '#000000',
  coolWhite: '#F5F6F7',
  prussianBlue: '#122A40',
  indigoDye: '#1A3E61',
  yinMnBlue: '#22527D',
  UCLABlue: '#327AB9',
  carolinaBlue: '#87B2D7',
  AliceBlue: '#DBE9F5',
  silver: '#C5C5C5',
  gray: '#7A7A7A',
  onyx: '#424242',
  mtdYellow: '#fcee1f',
  mtdYellowText: '#000000',
  mtdRed: '#ed1c24',
  mtdRedText: '#000000',
  mtdLavender: '#a78bc0',
  mtdLavenderText: '#000000',
  mtdBlue: '#355caa',
  mtdBlueText: '#ffffff',
  mtdGreen: '#008063',
  mtdGreenText: '#ffffff',
  mtdOrange: '#f99f2a',
  mtdOrangeText: '#000000',
  mtdGrey: '#808285',
  mtdGreyText: '#000000',
  mtdBronze: '#9e8966',
  mtdBronzeText: '#000000',
  mtdBrown: '#825622',
  mtdBrownText: '#ffffff',
  mtdGold: '#c7994a',
  mtdGoldText: '#000000',
  mtdRuby: '#eb008b',
  mtdRubyText: '#0000000',
  mtdTeal: '#6991',
  mtdTealText: '#ffffff',
  mtdSilver: '#cccccc',
  mtdSilverText: '#000000',
  mtdNavy: '#2b3088',
  mtdNavyText: '#ffffff',
  mtdPink: '#ffbfff',
  mtdPinkText: '#000000',
  mtdLime: '#b2d235',
  mtdLimeText: '#000000',
  mtdRaven: '#000000',
  mtdRavenText: '#ffffff',
  mtdIllini: '#5a1d5a',
  mtdIlliniText: '#ffffff',
  mtdLink: '#00ffff',
  mtdLinkText: '#000000',
}